import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Selectform } from "../../components/drop_down/Selectform";
import { exerciseType } from "../../components/constants/constants";
import { ListeningSetting } from "../../components/exercise_types_helper/listening_settings";
import { GrammarSetting } from "../../components/exercise_types_helper/grammar_settings";
import { WritingSetting } from "../../components/exercise_types_helper/writing_settings";
import { toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import { toLower } from "lodash";
import { GenaiUrl } from "../../libs/env";
import { ReadingSetting } from "../../components/exercise_types_helper/reading_settings";
import GenerateFormFilters from "../../components/filters/GenerateFormFilters";

const CreateExerciseForm = ({
  Dropdownitems,
  GenerateQuiz,
  data,
  setExerciseData,
  formError,
  IsGenerating,
  UserActiveToggle,
  setShowSocketData,
  formData,
  setFormData,
  clearformData,
  setIsStopGenerating,
  IsStopGenerating,
  setIsRegenerating,
  setIsGenerating,
  generate_button,
}) => {
  let params = new URL(document.location).searchParams;
  let use_template = params.get("use_template");
  let user_activation = window.sessionStorage.getItem("user_is_active");
  const [isvalidTheme, setisvalidTheme] = useState(null);
  const [taskquestionType, settaskquestionType] = useState([]);
  const [taskGrammars, settaskGrammars] = useState([]);
  const [taskLevels, settaskLevels] = useState([]);
  const [QuestypeIcon, setQuestypeIcon] = useState("");
  useEffect(() => {
    // Generate a random number to use as a suffix for the tab ID
    const randomSuffix = Math.floor(Math.random() * 1000000);

    // Create a unique tab ID by combining window.name and the random suffix
    const id = `${window.name}-${randomSuffix}`;

    // Set the tab ID state variable with the generated ID
    sessionStorage.setItem(`senderIDkey`, id);
  }, []);

  useEffect(() => {
    const channel = new BroadcastChannel(
      `tab-channel-${Dropdownitems?.user_id}`
    );
    if (IsGenerating) {
      channel.postMessage({
        type: "form-submitted",
        tabsenderKey: sessionStorage.getItem("senderIDkey"),
      });
    }
    channel.addEventListener("message", handleMessage);
  }, [IsGenerating, Dropdownitems]);

  function handleMessage(event) {
    const message = event.data;
    if (message.type === "form-submitted") {
      if (message.tabsenderKey !== sessionStorage.getItem("senderIDkey")) {
        // The message was sent from another tab
        setShowSocketData(false);
      } else {
        setShowSocketData(true);
      }
    }
  }

  const formSubmit = (event) => {
    event.preventDefault();
    if (window.location.pathname.includes(GenaiUrl)) {
      clearformData();
    }
    if (user_activation === "true") {
      if (Dropdownitems?.remaining_credits < formData?.credits) {
        toast.error(
          `*Insufficient credits: Add more credits for generate this exercise`,
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            toastId: 1,
          }
        );
      } else {
        GenerateQuiz(formData);
      }
    } else {
      UserActiveToggle();
    }
  };
  const handleSelectedValue = (event) => {
    let { name, value } = event;
    setisvalidTheme(null);
    if (window.location.pathname.includes(GenaiUrl)) {
      clearformData();
    }
    if (user_activation === "true") {
      let selected_voices = {}
      if (name === undefined) {
        name = "topic";
      }
      else if (name === "speaker_1" || name === "speaker_2") {
        selected_voices = formData?.voice_id ? formData?.voice_id : {}
        selected_voices[name] = value
        name = "voice_id";
        value = selected_voices
      }
      setFormData((prevState) => ({ ...prevState, [name]: value }));
      GenerateFormFilters(event, settaskquestionType, settaskGrammars, settaskLevels, setQuestypeIcon, Dropdownitems, formData, setFormData);
    } else {
      UserActiveToggle();
    }
  };
  useEffect(() => {
    setExerciseData((ExerciseData) => ({
      ...ExerciseData,
      task_level: formData?.cefr_level ? formData?.cefr_level : "A1",
      task_type: formData?.exercise_type
        ? formData?.exercise_type
        : "Reading Task",
      question_type: formData?.question_type
      ? formData?.question_type : "",
      question_type_icon: QuestypeIcon
      ? QuestypeIcon : "",
      question_reference_id: formData?.question_reference_id ? formData?.question_reference_id : "",
      grammar_reference_id: formData?.grammar_reference_id ? formData?.grammar_reference_id : "",
      recom_time: formData?.time_allowed ? formData?.time_allowed : "10",
      voice_id: formData?.voice_id ? formData?.voice_id : "",
      socket_id: formData?.socket_id,
    }));
  }, [formData, QuestypeIcon]);

  useEffect(() => {
    if (!use_template) {
      setFormData((formData) => ({
        ...formData,
        cefr_level: data?.exercise_form_prompt?.cefr_level
          ? data?.exercise_form_prompt.cefr_level
          : "",
        exercise_type: data?.exercise_form_prompt?.exercise_type
          ? data?.exercise_form_prompt.exercise_type
          : "",
        time_allowed: data?.exercise_form_prompt?.time_allowed
          ? data?.exercise_form_prompt.time_allowed
          : "",
        topic: data?.exercise_form_prompt?.topic
          ? data?.exercise_form_prompt.topic
          : "",
        question_type: data?.exercise_form_prompt?.question_type
          ? data?.exercise_form_prompt.question_type
          : "",
        options: data?.exercise_form_prompt?.options
          ? parseInt(data?.exercise_form_prompt.options)
          : "",
        questions: data?.exercise_form_prompt?.questions
          ? parseInt(data?.exercise_form_prompt.questions)
          : "",
        detail: data?.exercise_form_prompt?.detail
          ? data?.exercise_form_prompt.detail
          : "",
        grammar_type: data?.exercise_form_prompt?.grammar_type
          ? data?.exercise_form_prompt.grammar_type
          : "",
        task_style: data?.exercise_form_prompt?.task_style
          ? data?.exercise_form_prompt.task_style
          : "",
        formality: data?.exercise_form_prompt?.formality
          ? data?.exercise_form_prompt.formality
          : "",
        recom_words: data?.exercise_form_prompt?.recom_words
          ? data?.exercise_form_prompt.recom_words
          : "",
        credits: data?.exercise_form_prompt?.credits
          ? String(data?.exercise_form_prompt.credits)
          : "0",
        voice_id: data?.exercise_form_prompt?.voice_id
          ? data?.exercise_form_prompt.voice_id
          : "",

        socket_id: Dropdownitems?.user_id,
        question_reference_id: data?.exercise_form_prompt?.question_reference_id
          ? data?.exercise_form_prompt.question_reference_id
          : "",
        grammar_reference_id: data?.exercise_form_prompt?.grammar_reference_id
          ? data?.exercise_form_prompt.grammar_reference_id
          : "",
      }));
    }
  }, [data, use_template, Dropdownitems]);
  
  useEffect(()=>{
    if (window.location.pathname.includes(GenaiUrl) && !use_template && Dropdownitems && formData.exercise_type)
    {
      GenerateFormFilters(null, settaskquestionType, settaskGrammars, settaskLevels, setQuestypeIcon, Dropdownitems, formData, null);
    }
  },[formData, Dropdownitems, use_template])

  const handleInputChange = (event) => {
    let { name, value } = event.target;
    if (window.location.pathname.includes(GenaiUrl)) {
      clearformData();
    }
    if (user_activation === "true") {
      if (name === "cefr_level") {
        value = value.split(" ")[0];
      }
      if (name === "exercise_type") {
        if (value !== exerciseType.LISTENING_TASK) {
          setFormData((prevState) => ({ ...prevState, voice_id: "" }));
        }
        if (value === exerciseType.READING_TASK) {
          setFormData((prevState) => ({
            ...prevState,
            time_allowed: String(15),
          }));
        } else {
          setFormData((prevState) => ({
            ...prevState,
            time_allowed: String(10),
          }));
        }
        if (Dropdownitems?.exercise_credits) {
          Dropdownitems.exercise_credits.forEach((credit) => {
            if (credit.exercise_type === value) {
              setFormData((prevState) => ({
                ...prevState,
                credits: String(credit.estimated_credits),
              }));
            }
          });
        }
      }
      if (name === "question_type") {
        if (value === "Fill in the blank" || value === "Drag and drop") {
          setFormData((prevState) => ({ ...prevState, options: 1 }));
        }
      }
      setFormData((prevState) => ({ ...prevState, [name]: value }));
      if (!formData.socket_id) {
        setFormData((prevState) => ({
          ...prevState,
          socket_id: Dropdownitems?.user_id,
        }));
      }
      GenerateFormFilters(event.target, settaskquestionType, settaskGrammars, settaskLevels, setQuestypeIcon, Dropdownitems, formData, setFormData);
    } else {
      UserActiveToggle();
    }
  };
  const handleScroll = (e) => {
    var timer;
    const container = e.target;
    if (container) {
      container.classList.add("scrollable_scroll");
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      container.classList.remove("scrollable_scroll");
    }, 1000);
  };
  const getCompleteLevel = (level) => {
    switch (level) {
      case "a1":
        return "A1 (Beginner)";
      case "a2":
        return "A2 (Pre-Intermediate)";
      case "b1":
        return "B1 (Intermediate)";
      case "b2":
        return "B2 (Upper-Intermediate)";
      case "c1":
        return "C1 (Advanced)";
      case "c2":
        return "C2 (Proficiency)";
      default:
        return level;
    }
  };

  return (
    <form onSubmit={formSubmit}>
      <Row className="g-0 px-2">
        <div>
          <div className="p-4 pe-1 custom-task">
            <div className="template_scroll" onScroll={handleScroll}>
              <div className="pb-2">
                <h2 class="fs-5">
                  <svg
                    width="25"
                    height="26"
                    viewBox="0 0 25 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.68458 24V18.5M4.68458 7.5V2M2 4.75H7.36915M2 21.25H7.36915M13.8121 3.1L11.9499 8.05975C11.6471 8.8663 11.4957 9.26958 11.2602 9.60879C11.0515 9.90944 10.7951 10.1721 10.5016 10.3859C10.1705 10.6271 9.77678 10.7822 8.98941 11.0924L4.14766 13L8.98941 14.9076C9.77678 15.2178 10.1705 15.3729 10.5016 15.6141C10.7951 15.8279 11.0515 16.0906 11.2602 16.3912C11.4957 16.7304 11.6471 17.1337 11.9499 17.9403L13.8121 22.9L15.6743 17.9403C15.9772 17.1337 16.1286 16.7304 16.3641 16.3912C16.5727 16.0906 16.8292 15.8279 17.1227 15.6141C17.4538 15.3729 17.8475 15.2178 18.6349 14.9076L23.4766 13L18.6349 11.0924C17.8475 10.7822 17.4538 10.6271 17.1227 10.3859C16.8292 10.1721 16.5727 9.90944 16.3641 9.60879C16.1286 9.26958 15.9772 8.8663 15.6743 8.05975L13.8121 3.1Z"
                      stroke="#2E58D4"
                      stroke-width="2.14766"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <b className="ps-2">Create your own task</b>
                </h2>
              </div>
              <Row className={"g-0"}>
                <Col className="col-12 sm-flex">
                  <Col lg={6} sm={12} className="ps-1 pe-3 pt-3">
                    <label class="pb-2 fw-600" for="Skill">
                      Skill
                    </label>
                    <div class="form-group md-group show-label">
                      <Selectform
                        className="form-select custom-select-bold"
                        name="exercise_type"
                        placeholder={"Select skill"}
                        selectedvalue={formData.exercise_type}
                        choices={Dropdownitems.exercise_type_choices}
                        onChange={handleInputChange}
                        disabled={IsGenerating}
                        required
                      />
                    </div>
                  </Col>
                  <Col lg={6} sm={12} className="pe-3 ps-1 pt-3">
                    <label class="pb-2 fw-600" for="cefr_level">
                      CEFR level
                    </label>
                    <div class="form-group md-group show-label">
                      <Selectform
                        className="form-select custom-select-bold"
                        name="cefr_level"
                        selectedvalue={getCompleteLevel(
                          toLower(formData.cefr_level)
                        )}
                        placeholder={"Select level"}
                        choices={taskLevels.map((level) => {
                          return getCompleteLevel(
                            toLower(level)
                          )
                        })}
                        onChange={handleInputChange}
                        disabled={IsGenerating}
                        required
                      />
                    </div>
                  </Col>
                </Col>
                {formData?.exercise_type === exerciseType.LISTENING_TASK && (
                  <Col className="col-12 sm-flex">
                    <ListeningSetting
                      handleSelectedValue={handleSelectedValue}
                      formData={formData}
                      Dropdownitems={Dropdownitems}
                      handleInputChange={handleInputChange}
                      IsGenerating={IsGenerating}
                      isvalidTheme={isvalidTheme}
                      p_class={"ps-1"}
                    />
                  </Col>
                )}
              </Row>
              <div>
                <Col className="col-12">
                  <div class="col-12 sm-flex">
                    <div class="col-12 pe-3 ps-1 pt-3">
                      <label class="pb-2 fw-600" for="topic">
                        Topic / learning objective
                      </label>
                      <div>
                        <textarea
                          class="form-control sm-form-rounded py-2"
                          name="detail"
                          rows="5"
                          cols="97"
                          placeholder="Make the task about popular foods around the world. Include all types of cuisines."
                          value={formData.detail}
                          onChange={handleInputChange}
                          disabled={IsGenerating}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </Col>
              </div>
              {formData?.exercise_type === exerciseType.GRAMMAR_TASK &&
              taskGrammars.length > 0 ? (
                <GrammarSetting
                  handleSelectedValue={handleSelectedValue}
                  formData={formData}
                  handleInputChange={handleInputChange}
                  IsGenerating={IsGenerating}
                  taskGrammars={taskGrammars}
                  taskquestionType={taskquestionType}
                />
              ) : formData?.exercise_type === exerciseType.WRITING_TASK ? (
                <div>
                  <WritingSetting
                    handleSelectedValue={handleSelectedValue}
                    formData={formData}
                    Dropdownitems={Dropdownitems}
                    handleInputChange={handleInputChange}
                    IsGenerating={IsGenerating}
                    isvalidTheme={isvalidTheme}
                  />
                </div>
              ) : (
                <ReadingSetting
                  formData={formData}
                  handleInputChange={handleInputChange}
                  IsGenerating={IsGenerating}
                  taskquestionType={taskquestionType}
                />
              )}
            </div>
            <div className="col-12 d-flex align-items-center pt-4 ps-1 pe-4">
              <Col className="col-12 text-center">
                {IsGenerating ? (
                  <button
                    class="btn btn-darkblue px-4 w-100 rounded-5 fs-8"
                    type="button"
                    onClick={() => {
                      setIsStopGenerating(true);
                      setIsGenerating(false);
                      setIsRegenerating(false);
                    }}
                  >
                    <span
                      class="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Stop generating
                  </button>
                ) : !IsGenerating && IsStopGenerating ? (
                  <>
                    <button
                      class="btn btn-darkblue px-4 w-100 py-1 rounded-5 fs-8"
                      type="button"
                      onClick={() => {
                        setIsStopGenerating(false);
                        setIsGenerating(true);
                        setIsRegenerating(true);
                        generate_button();
                      }}
                    >
                      <svg
                        width="20"
                        height="22"
                        viewBox="0 0 16 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.94185 1L1.38706 8.4815C1.13036 8.7745 1.002 8.921 1.00004 9.04472C0.998337 9.15228 1.04873 9.25461 1.13669 9.32222C1.23788 9.4 1.43837 9.4 1.83936 9.4H7.2059L6.46994 15L13.0247 7.5185C13.2814 7.2255 13.4098 7.079 13.4118 6.95528C13.4135 6.84772 13.3631 6.74539 13.2751 6.67777C13.1739 6.6 12.9734 6.6 12.5724 6.6H7.2059L7.94185 1Z"
                          stroke="white"
                          stroke-width="1.4719"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <b className="ps-1">Regenerate Task</b>
                    </button>
                    <button
                      type="submit"
                      rel="nofollow"
                      id="SubmitForm"
                      class="d-none"
                    >
                      <b>Regenerate</b>
                    </button>
                  </>
                ) : (
                  <button
                    type="submit"
                    href="#"
                    rel="nofollow"
                    id="SubmitForm"
                    class="btn btn-darkblue px-4 w-100  rounded-5 fs-18"
                  >
                    <svg
                      width="20"
                      height="22"
                      viewBox="0 0 16 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.94185 1L1.38706 8.4815C1.13036 8.7745 1.002 8.921 1.00004 9.04472C0.998337 9.15228 1.04873 9.25461 1.13669 9.32222C1.23788 9.4 1.43837 9.4 1.83936 9.4H7.2059L6.46994 15L13.0247 7.5185C13.2814 7.2255 13.4098 7.079 13.4118 6.95528C13.4135 6.84772 13.3631 6.74539 13.2751 6.67777C13.1739 6.6 12.9734 6.6 12.5724 6.6H7.2059L7.94185 1Z"
                        stroke="white"
                        stroke-width="1.4719"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <b className="ps-1">Generate your own version</b>
                  </button>
                )}
              </Col>
            </div>
          </div>
        </div>
      </Row>
    </form>
  );
};

export default CreateExerciseForm;
